import { createGlobalStyle } from "styled-components";

import { iconWhiteClose } from "assets/icons";

const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: 'Aeonik';
  src: url('https://publicwebsitestatic.s3.amazonaws.com/fonts/aeonik-font/Aeonik-Regular.woff') format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Aeonik-bold';
  src: url('https://publicwebsitestatic.s3.amazonaws.com/fonts/aeonik-font/Aeonik-Bold.woff') format('woff');
  font-weight: 700;
  font-style: normal;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}


/**
 * Fix fonts that render as bold in Firefox
 */

html {
  font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  height: 100%;
}

/**
 * Firefox specific rule
 */

@-moz-document url-prefix() {
  body {
    font-weight: lighter !important;
  }
}



footer,
header,
nav,
section,
main {
  display: block;
}

body {
  overflow: hidden;
  margin: 0;
  height: 100%;
  color: ${({ theme }) => theme.global.color.bodyColor};
  font-family: ${({ theme }) => theme.global.fonts.aeonik};

  --bs-list-group-bg: ${({ theme }) => theme.dropdown.bg.primary};
  --bs-body-bg: ${({ theme }) => theme.dropdown.bg.primary};;

  #root {
    height: 100%;    
  }

  .button {
    text-transform: none;
  }

  .modal-backdrop {
    background-color: #202c40;
  }
  
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;

    .on-btn {
      --bs-spinner-width: 1.5em;
      --bs-spinner-height: 1.5em;
      --bs-spinner-border-width: 0.2em;
    }
  }

  .gain {
    color: ${({ theme }) => theme.constants.COLOR_GREEN};
  }

  .gain-v2 {
    color: ${({ theme }) => theme.constants.COLOR_GREEN};
    background-color: ${({ theme }) => theme.global.bg.profit};
    padding: 5px;
    border-radius: 25px;
    min-width: 65px;
    max-width:75px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap:4px;
  }
  
  .loss {
    color: ${({ theme }) => theme.constants.COLOR_RED};
  }

  .loss-v2 {
    color: ${({ theme }) => theme.constants.COLOR_RED};
    padding: 5px;
    border-radius: 25px;
    background-color: ${({ theme }) => theme.global.bg.loss};
    min-width: 65px;
    max-width:75px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap:4px;

  }

  .recharts-pie * {
    outline: none !important;
  }

  .sticky-card {
    position: sticky;
    top: -16px;
    z-index: 1000;
  }

  /* Tooltip container */
  .app-tooltip {
    position: relative;   
    align-items: center;
    display: inline-flex;
    


    &:hover .tooltiptext {
      visibility: visible;
    }

    .tooltiptext {
      font-size: 0.7rem;
      font-weight: 400;
      visibility: hidden;
      min-width: 150px;
      background-color: ${({ theme }) => theme.chart.tooltip.primary};
      color: ${({ theme }) => theme.card.font.tertiary};
      text-align: center;
      padding: 0.25rem 0.5rem;
      border-radius: 10px;
      left: 110%;
      box-shadow: "0px 4px 15px 0px #00000033";
      /* Position the tooltip text - see examples below! */
      position: absolute;
      z-index: 1;

      &.right {
        left: 110%;
      }
      &.left {
        right: 110%;
      }
      &.top {
        bottom: 110%;
        left: 50%;
        margin-left: -50px; /* Use half of the width (120/2 = 60), to center the tooltip */
      }
      &.bottom {
        top: 110%;
        left: 50%;
        margin-left: -50px; /* Use half of the width (120/2 = 60), to center the tooltip */
      }

      &.mw-200px {
        min-width: 200px;
      }
    }
  }
  
  .chart-tooltip {
    background: ${({ theme }) => theme.chart.tooltip.primary};
    box-shadow: ${({ theme }) => theme.card.shadow};
    color: ${({ theme }) => theme.chart.tooltip.tertiary};
    border-radius: 10px;
    padding: 5px 10px;
    border: 0;

    .datetime {
      font-size: 10px;
    }
    .hp-datetime {
      font-size: 14px;
      color: ${({ theme }) => theme.chart.tooltip.tertiary};
    }
    .label {
      font-size: 12px;
    }
  }

  .chart-tooltip-traders {
    background: ${({ theme }) => theme.chart.tooltip.quaternary};
    box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    padding: 5px 10px;
    border: 0;
    display: flex;
    flex-direction: column;

    .tooltip-date{
      font-size: 13px;
      padding-left: 6px;
    }

    .tooltip-container {
      display: flex;
      justify-content: space-between;
      gap:3px;
      width: 180px;
      
      .trade-wrapper {
        width: 50%;
        padding: 6px;
        margin: 0px;
        background-color: transparent;

        .label {
          font-size: 12px;

          &.buy {
            color: ${({ theme }) => theme.global.color.profit}; 
          }

          &.sell {
            color: #ff3f3f;
          }
        }
        
        .divider {
          height: 3px;
          margin-top: 4px;
          border: 0;

          &.buy {
            background-color: ${({ theme }) => theme.global.color.profit};
          }

          &.sell {
            background-color: #ff3f3f;
          }
        }
      }      
    }
  }

  .disabled {
    cursor: not-allowed !important;
  }

  button[disabled] {
    cursor: not-allowed !important;
    background: #FFF !important;
    color: #414651 !important;
    border: 1px solid #D5D7DA !important;
  }

  .divider {
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.divider.bg.secondary};
    margin: 0.5em 0;
  }

  .v-divider {
    height: 100%;
    border-right: 1px solid ${({ theme }) => theme.divider.bg.primary};
  }

  .tooltip{
    font-family: ${({ theme }) => theme.global.fonts.aeonik};

    &.show {
      opacity: 1;
    }

    & > div.tooltip-inner {
      border: 1px solid ${({ theme }) => theme.card.border.primary};
      background: ${({ theme }) => theme.tooltip.bg.primary}; 
      color: ${({ theme }) => theme.tooltip.font.color};
      text-align: left;
    }
    
    &.bs-tooltip-bottom .tooltip-arrow::before{
      border-bottom-color: ${({ theme }) => theme.tooltip.border.primary};  
      border-left-color: transparent;  
      border-right-color: transparent;  
    }

    &.bs-tooltip-top .tooltip-arrow::before{
      border-top-color: ${({ theme }) => theme.tooltip.border.primary};  
      border-left-color: transparent;  
      border-right-color: transparent;  
    }

    & > .tooltip-arrow::before {
      border-left-color: ${({ theme }) => theme.tooltip.border.primary};  
      border-right-color: ${({ theme }) =>
        theme.tooltip.border.primary};        
    }

    &[data-popper-placement="left-start"]{
      margin-top: -10px;
      & > .tooltip-arrow::before{
        top: 10px;
      }
    }
    
    &.tooltip-wrapper {
      background: ${({ theme }) => theme.chart.tooltip.primary};
          border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};  
      z-index: 9999;
      margin-bottom: 10px;
      padding: 0;
    
      .tooltip-inner {
        background:${({ theme }) => theme.chart.tooltip.primary};
        color: #131316;
        max-width: 300px;
        text-align: start;
      }
    
      .tooltip-arrow::before {
        border-top-color: ${({ theme }) => theme.tooltip.border.primary};
        border-left-color: transparent;
        border-right-color: transparent;
        top: 7px;
      }
    
      .action-details {
        .action-name {
          display: flex;
          align-items: center;
          margin-bottom: 6px;
    
          p {
            font-weight: 400;
            font-size: 12px;
            color: ${({ theme }) => theme.card.font.tertiary};
            margin-bottom: 0;
          }
    
          img {
            margin-right: 6px;
          }
        }
      }
    }

    &.premium-tooltip {
      max-width: 374px;
      min-width: 330px;
      box-shadow: 0px 4px 15px 0px #00000033;
      padding: 0px;

      .tooltip-arrow {
        display: none;
      }

      .tooltip-inner {
        min-width: 100%;
        padding: 0px;
        background-color:${({ theme }) => theme.chart.tooltip.primary} ;
        border: 0px;
        width: 100%;
       color: ${({ theme }) => theme.chart.tooltip.tertiary}; 
       
      }
    }


    &.v2-tooltip {
      max-width: auto;
      min-width: auto;
      box-shadow: 0px 4px 15px 0px #00000033;
      padding: 2px 2px;
      border-radius: 10px;

      &.total-value {
        max-width: 374px;
        min-width: 330px;

        .tooltip-inner {
          min-width: 100%;
        }
      }

      .tooltip-arrow {
        display: none;
      }

      .tooltip-inner {
        min-width: 100%;
        padding: 4px 10px;
        background-color:${({ theme }) => theme.chart.tooltip.primary} ;
        border: 0px;
        width: 100%;
        border-radius: 10px;
       color: ${({ theme }) => theme.chart.tooltip.tertiary}; 
       font-size: 14px;
       
      }
    }
  }
}
/* body end */

ol,
ul {
  list-style: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

input {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 0;
}

button.unset {
  all: unset;
}

.color-primary {
  color: ${({ theme }) => theme.global.text.primary} !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.renew-text {
  color: ${({ theme }) => theme.global.color.bodyColor};
  font-size: 14px;
  font-weight: 400;
}

.host-desc {
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.global.extraInfo.font.color};
}


.delete-strat-text {
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.global.extraInfo.font.color};
  margin-bottom: 0px;
}

.bg-dark {
  background-color: ${({ theme }) => theme.global.color.secondary};
}

.no-data {
  color: ${({ theme }) => theme.global.color.noData};
  font-weight: 600;
  font-size: 14px;
  margin-top: 0 1em;
}

.fs {
  &-14 {
    font-size: 14px !important;
  }
}

.text-left {
  text-align: left;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toast-container {
  margin: 2em;
  z-index: 99999;

  &.top-0 {
    margin-top: 5em;
  }
  .toast {
    background: ${({ theme }) => theme.toast.bg.primary};

    .toast-main-header-v2 {
      padding: 4px 7px 4px 6px !important;
      border-top-left-radius: calc(3px - var(--bs-toast-border-width));
      border-top-right-radius: calc(3px - var(--bs-toast-border-width));
      font-size: 15px;

      .toast-header-v2 {
        font-weight: 500;

      }
    }

    .toast-header{
      padding: 7px 10px 8px 10px;
      color: #ffffff;
      background-color: ${({ theme }) => theme.toast.bg.primary};

      &.info {
        background-color: ${({ theme }) => theme.toast.bg.info};
      }
      &.error {
        background-color: ${({ theme }) => theme.toast.bg.error};
      }
      .btn-close {
        background: url("${iconWhiteClose}") center/1em auto no-repeat;
        opacity: 1;
      }
    }
    .toast-body {
      padding: 10px 10px 30px;
      font-size: 14px;
      font-weight: 600;
      opacity: 0.8; 
    }

    .toast-body-v2 {
      color: ${({ theme }) => theme.card.font.tertiary};
      font-size: 15px;
      font-weight: 400;
      padding: 10px 10px 44px;
    }
  }
}

.desktop-view {
  display: none;  
}

.mobile-view {
  display: none;
  padding-top: 20px;
}

.tablet-view {
  display: none;
}


.info-icon {
  width: 14px;
  height: 14px;
  opacity: 0.6;
  cursor: pointer;
}

.blur-overlay {
  position: relative;
  filter: blur(4px);
  -o-filter: blur(4px);
  -ms-filter: blur(4px);
  -moz-filter: blur(4px);
  -webkit-filter: blur(4px);
  pointer-events: none;
  user-select: none;
  z-index: 1;

  * {
    pointer-events: none !important;
  }
}

.form-check-input {
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.global.color.septenary};
}

#sc_date_of_birth .react-datepicker-popper .react-datepicker__triangle::after, #sc_date_of_birth .react-datepicker-popper .react-datepicker__triangle::before {
  left: -30px;
}

/* Ensure calendar popup works in modals */
#personal_details_date_of_birth {
  z-index: 9999 !important;
}

#personal_details_date_of_birth .react-datepicker-popper {
  z-index: 9999 !important;
}

#personal_details_date_of_birth .react-datepicker__portal {
  z-index: 9999 !important;
}


// Animation 
.app__animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-duration: var(--animate-duration);
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animate__slideInCenter {
  -webkit-animation-name: slideInCenter;
  animation-name: slideInCenter;
}

@keyframes slideInCenter {
  from {
    -webkit-transform: translate3d(-55%, 0, 0);
    transform: translate3d(-55%, 0, 0);
  }
  
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.animate__slideOutCenter {
  -webkit-animation-name: slideOutCenter;
  animation-name: slideOutCenter;
}

@keyframes slideOutCenter {
  from {
    -webkit-transform: translate3d(55%, 0, 0);
    transform: translate3d(55%, 0, 0);
  }
  
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.animate__slideOutLeft {
  -webkit-animation-name: slideOutLeft;
  animation-name: slideOutLeft;
}

@keyframes slideOutLeft {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    -webkit-transform: translate3d(-10%, 0, 0);
    transform: translate3d(-10%, 0, 0);
  }
}

.animate__slideOutRight {
  -webkit-animation-name: slideOutRight;
  animation-name: slideOutRight;
}

@keyframes slideOutRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    -webkit-transform: translate3d(10%, 0, 0);
    transform: translate3d(10%, 0, 0);
  }
}


 /* Media Query for Tablets Ipads portrait mode */
 @media (min-width: 768px) and (max-width: 1024px){
  .tablet-view {
    display: block;
  }
}

@media (min-width: 768px) {
  .desktop-view {
    display: block;
  }
}

@media (max-width: 767px) {
  .mobile-view {
    display: block;
    padding-top: 0;
  }
 
  .toast-container {
    margin: 2em 10px;
  }
}

::-webkit-scrollbar { width: 7px; height:5px; position:absolute; }
::-webkit-scrollbar-track { background: transparent; }
:hover::-webkit-scrollbar-thumb { background: ${({ theme }) =>
  theme?.global?.scroll?.primary}; border-radius:10px; }
::-webkit-scrollbar-thumb:horizontal:hover,
::-webkit-scrollbar-thumb:vertical:hover { background:${({ theme }) =>
  theme?.global?.scroll?.primary}; border-radius:10px; }
::-webkit-scrollbar-thumb:horizontal:active,
::-webkit-scrollbar-thumb:vertical:active { background:${({ theme }) =>
  theme?.global?.scroll?.primary}; border-radius:10px; }

`;

export default GlobalStyle;
